import { injectable } from 'inversify';

import {
  GetCompanyEmployeesResponse,
  GetUnitTypesResponse,
} from '@app/gen/organization';
import {
  PolicyCategoryItem,
  PolicyCompany,
  FilterSelectOption,
} from '@app/gen/policy';

import { TreeNode } from '../types/tree-node';

@injectable()
export class CreationMapper {
  processCreatePolicyCompany(companies: PolicyCompany[]) {
    return companies.map((company) => ({
      label: company.name,
      value: company.company_id,
      hasChildCompanies: company.has_child_companies,
    }));
  }

  processCompanyPositions(positions: FilterSelectOption[]) {
    return positions.map(({ label, value }) => ({
      label,
      value,
    }));
  }

  processPolicyEmployees(employees: GetCompanyEmployeesResponse) {
    return employees.employees.map(
      ({ id, name, personnel_number, position }) => ({
        label: name,
        value: id,
        prefix: personnel_number,
        position,
      }),
    );
  }

  policyUnitTypeSorting(values: GetUnitTypesResponse) {
    const legalType = values?.types.find(
      (unitType) => unitType.type === 'legal',
    );
    const filteredTypes = values?.types?.filter(
      (unitType) => unitType.type !== 'legal',
    );
    const newArr = legalType ? [legalType, ...filteredTypes] : filteredTypes;

    return { types: newArr };
  }

  processGovDocumentOptions(govDocumentOptions: FilterSelectOption[]) {
    return govDocumentOptions.map(({ label, value }) => ({
      value,
      label: `${value}, ${label}`,
    }));
  }

  processTree(node: PolicyCategoryItem): TreeNode {
    return {
      id: node.id,
      label: node.name,
      hasChildrenToLoad: node.have_children,
      subtext: node?.subtext,
      children: node?.children
        ? (node.children || []).map((item) => this.processTree(item))
        : [],
    };
  }

  processSearchOptions(node: PolicyCategoryItem): TreeNode {
    return {
      id: node.id,
      label: node.name,
      subtext: node?.subtext,
    };
  }
}
